import { create } from "zustand";
import { ADDRESS_KEYS } from "../../modules/InternationalPayment/InternationalPayment.constants";

export const useInternationalPaymentStore = create((set) => ({
  isEnabled: false,
  addressData: null,
  listingUuid: null,

  setIsEnabled: (isEnabled) => set({ isEnabled }),
  setAddressData: (addressData) => set({ addressData }),
  setListingUuid: (listingUuid) => set({ listingUuid }),

  initFromConfig: (configData, listingUuid) => {
    const { is_enabled } = configData;
    const addressData = ADDRESS_KEYS.reduce(
      (acc, key) => ({ ...acc, [key]: configData[key] }),
      {}
    );
    const hasData = ADDRESS_KEYS.some((key) => configData[key]);
    set({
      isEnabled: !!is_enabled,
      listingUuid: listingUuid ?? null,
      addressData: hasData ? addressData : null,
    });
  },
}));
